import styled from 'styled-components';

export const StyledNoItemsFound = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .no-items-found {
    width: 100%;
    max-width: 400px;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    text-align: center;
  }

  @media (max-width: 768px) {
    .no-items-found {
      white-space: pre-wrap;
    }
  }
`;
